// Resource displays include time worked even when it has been written off.
export const getWorkedHours = (entry) =>
  (parseFloat(entry.workHour) || 0) +
  (parseFloat(entry.discountedHours) || 0);
